// src/Services/AuthService.js
import apiCall from "../utils/apiInterceptor";
import { ServiceProvider } from "./ServiceProvider";

class AuthService {
  static async login(email, password) {
    try {
      // Login doesn't need token refresh interceptor
      const response = await fetch(ServiceProvider.auth.login, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Login failed");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Unable to process your request, Please contact administrator");
    }
  }

  static async logout(token) {
    try {
      const response = await apiCall(ServiceProvider.auth.logout, {
        method: "POST",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Logout failed");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Unable to process your request, Please contact administrator");
    }
  }

  static async selectBranch(branchId, token) {
    try {
      const response = await fetch(ServiceProvider.auth.selectBranch, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id: branchId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Branch selection failed");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Unable to process branch request");
    }
  }

  // Example of other methods that should use apiCall
  static async getUserProfile() {
    try {
      const response = await apiCall(ServiceProvider.user.profile, {
        method: "GET",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch profile");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Unable to fetch user profile");
    }
  }
}

export default AuthService;